import { TwitterIcon, FacebookIcon, InstagramIcon, YoutubeIcon, LinkedinIcon } from '@domain-group/fe-co-icon';
export var socialLinks = [{
  icon: FacebookIcon,
  text: 'Facebook',
  href: 'http://www.facebook.com/allhomes'
}, {
  icon: InstagramIcon,
  text: 'Instagram',
  href: 'https://www.instagram.com/allhomes.com.au/'
}, {
  icon: YoutubeIcon,
  text: 'YouTube',
  href: 'https://www.youtube.com/allhomesaus'
}, {
  icon: TwitterIcon,
  text: 'Twitter',
  href: 'http://twitter.com/allhomescomau'
}, {
  icon: LinkedinIcon,
  text: 'LinkedIn',
  href: 'https://www.linkedin.com/company/allhomes-com-au'
}];